import React from "react";
import { Palmtree } from "lucide-react";

// Recreated text-based TNT LEGACY logo in matching blue style
const Logo = ({ compact = false }) => {
  return (
    <div className="flex flex-col items-center leading-none select-none">
      <div className="flex items-end gap-1">
        <Palmtree
          className={`${compact ? "h-5 w-5" : "h-7 w-7"} text-[#7fd8f7] -mb-1`}
          strokeWidth={2}
        />
        <span
          className={`font-display ${
            compact ? "text-2xl" : "text-4xl md:text-5xl"
          } tracking-tight bg-gradient-to-b from-[#7fd8f7] via-[#35c6f4] to-[#0a6bb0] bg-clip-text text-transparent drop-shadow`}
        >
          TNT
        </span>
      </div>
      <span
        className={`font-display ${
          compact ? "text-lg -mt-0.5" : "text-2xl md:text-3xl -mt-1"
        } tracking-[0.15em] bg-gradient-to-b from-white to-slate-300 bg-clip-text text-transparent`}
      >
        LEGACY
      </span>
      <span
        className={`font-cond ${
          compact ? "text-[8px]" : "text-[10px] md:text-xs"
        } tracking-[0.35em] text-[#7fd8f7] uppercase mt-0.5`}
      >
        Property Services
      </span>
    </div>
  );
};

export default Logo;
